import { useTenantContext } from '@trashlab/sitesapp/src/contexts/use-tenant-context';
import { trpcPricingListSkusOpen } from '@trashlab/api/src/generated/hooks';
import { useShoppingCart } from '@trashlab/sitesapp/src/hooks/use-shopping-cart';

export const NotSureCtaSection = () => {
  const { website } = useTenantContext();
  const tenantId = website?.organization?.id;
  const { isLoading, addToCart } = useShoppingCart();

  const { data: skus } = trpcPricingListSkusOpen.useQuery(
    {
      tenantId: tenantId ?? '',
      onlineOrderEnabled: true,
      status: 'ACTIVE',
      defaultOnly: true,
    },
    { enabled: !!tenantId },
  );

  const getSku = (yardage: number) =>
    skus?.find((s) => {
      const raw = s.product?.cubicYardage;
      const num =
        typeof raw === 'string'
          ? parseInt(raw.replace(/\D/g, ''), 10) || 0
          : Number(raw) || 0;
      return num === yardage;
    });

  const fiveYdSku = getSku(5);
  const tenYdSku = getSku(10);

  const handleOrder = async (skuId: string, productId: string) => {
    await addToCart({ skuId, productId });
  };

  return (
    <section className="py-16 bg-[#333333] text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 italic">
            Not Sure? Just Ask — We&apos;ll Figure It Out Together
          </h2>
          <p className="text-white/90 leading-relaxed mb-8 text-lg">
            Choosing a dumpster size doesn&apos;t have to be complicated. Call or text{' '}
            <a href="tel:9529312577" className="text-[#FFEB3B] font-semibold hover:underline">
              952-931-2577
            </a>{' '}
            and describe your project in one sentence. We&apos;ll recommend the right size, confirm
            availability, and get you scheduled — often for same-day or next-day delivery.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-6">
            {fiveYdSku && fiveYdSku.product?.id && (
              <button
                onClick={() => handleOrder(fiveYdSku.id, fiveYdSku.product!.id)}
                disabled={isLoading}
                className="bg-[#E31837] hover:bg-[#C1152E] text-white font-bold py-4 px-8 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-lg shadow-lg"
              >
                {isLoading ? 'Loading...' : 'Order 5YD'}
              </button>
            )}
            {tenYdSku && tenYdSku.product?.id && (
              <button
                onClick={() => handleOrder(tenYdSku.id, tenYdSku.product!.id)}
                disabled={isLoading}
                className="bg-[#E31837] hover:bg-[#C1152E] text-white font-bold py-4 px-8 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-lg shadow-lg"
              >
                {isLoading ? 'Loading...' : 'Order 10YD'}
              </button>
            )}
          </div>

          <a
            href="tel:9529312577"
            className="inline-block text-[#FFEB3B] hover:text-yellow-300 font-semibold text-lg hover:underline transition-colors"
          >
            Call Now: 952-931-2577
          </a>
        </div>
      </div>
    </section>
  );
};
